import Component from '../core/Component'
import {EMITS as ROOMCARD_EMITS} from './RoomCard'
import { CMS } from '../core/config'
import Scroll from '../services/Scroll'

export const STATES = {
    READY: 'is-ready'
}

export const EMITS = {
    SLIDE_SELECTED: 'selected'
}

export default class RoomSlider extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            placeholder: null,
            cards: []
        }

        this.cards = []

        this.index = 0
    }

    prepare() {
        if (CMS) {
            return
        }

        this.ref.cards.forEach(card => card.id = `roomcard-${card.id}`) //fake id aby neskakalo okno

        this.cards = this.ref.cards.map(card => Component.getFromElement(card))
        this.cards.forEach(card => card.on(ROOMCARD_EMITS.CHANGE, this.handleResize))

        this.resize()
        Scroll.on('resize-x', this.handleResize)

        this.element.classList.add(STATES.READY)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        this.ref.placeholder.style.height = `${this.ref.cards[this.index].getBoundingClientRect().height}px`
    }

    select(index) {
        if (!this.cards[index]) {
            return
        }

        this.cards[this.index].hide()
        this.index = index
        this.cards[this.index].show()
        this.resize()
    }
}

